import React, { ChangeEvent, FormEvent, useCallback, useState } from 'react';

import { Box, Button, FormControl, Stack, TextField } from '@mui/material';

import InputCruiseLineSelect from '~/components/Cruises/components/Selects/InputCruiseLineSelect';

import { CruiseLine } from '~/services/cruises/CruiseLineService';

import { SEARCH_FILTERS_DEFAULT, SearchFilters } from './constants';

type Props = {
  querySearchFilters: SearchFilters;
  onSearch: (params: SearchFilters) => void;
};

export default function CabinCategoriesGroupSearchFilters(props: Props) {
  const { querySearchFilters, onSearch } = props;

  const [searchFilters, setSearchFilter] = useState<SearchFilters>({
    ...SEARCH_FILTERS_DEFAULT,
    ...querySearchFilters,
  });

  const handleChangeField = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.persist) event.persist();

      if (event?.target && event?.target?.name) {
        setSearchFilter((prev) => ({
          ...prev,
          [event.target.name]: event.target.value,
        }));
      }
    },
    [setSearchFilter],
  );

  const handleSearch = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      onSearch({
        id: searchFilters.id,
        name: searchFilters.name,
        shipId: searchFilters.shipId,
        shipName: searchFilters.shipName,
        vendorId: searchFilters.vendorId,
        cabinCategoryCode: searchFilters.cabinCategoryCode,
        shipExternalId: searchFilters.shipExternalId,
      });
    },
    [searchFilters, onSearch],
  );

  const handleCruiseLineField = useCallback(
    (cruiseLine?: CruiseLine) => {
      if (!cruiseLine?.id) {
        return;
      }

      setSearchFilter((prev) => ({ ...prev, vendorId: cruiseLine.id }));
    },
    [setSearchFilter],
  );

  return (
    <form autoComplete="off" onSubmit={handleSearch}>
      <Box display="flex" flexDirection="column" gap={2}>
        <Stack display="flex" direction="row" gap={2}>
          <TextField
            fullWidth
            name="id"
            label="Cabin Category Group ID"
            onChange={handleChangeField}
            value={searchFilters.id}
          />
          <TextField
            fullWidth
            name="name"
            label="Cabin Category Group Name"
            onChange={handleChangeField}
            value={searchFilters.name}
          />
          <TextField
            fullWidth
            name="cabinCategoryCode"
            label="Cabin Category Code"
            onChange={handleChangeField}
            value={searchFilters.cabinCategoryCode}
          />
          <FormControl fullWidth>
            <InputCruiseLineSelect
              label="Cruise line"
              value={searchFilters.vendorId}
              onChange={handleCruiseLineField}
            />
          </FormControl>
        </Stack>

        <Stack display="flex" direction="row" gap={2}>
          <TextField
            fullWidth
            name="shipId"
            label="Ship ID"
            onChange={handleChangeField}
            value={searchFilters.shipId}
          />
          <TextField
            fullWidth
            name="shipExternalId"
            label="Ship External ID"
            onChange={handleChangeField}
            value={searchFilters.shipExternalId}
          />
          <TextField
            fullWidth
            name="shipName"
            label="Ship Name"
            onChange={handleChangeField}
            value={searchFilters.shipName}
          />
          <Box>
            <Button type="submit" variant="contained">
              Search
            </Button>
          </Box>
        </Stack>
      </Box>
    </form>
  );
}
